module.exports = __webpack_public_path__ + "img/cat-04-ac.034e89c2.svg";